import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";
import store from '@/store'
import { setToken, getApplyToken } from '@/utils/auth'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: '/index',
    component: Layout,
    meta: { title: '首页' },
    children: [
      {
        path: '/index',
        name: 'HomePage',
        component: () => import('@/views/Home'),
        meta: { title: '首页' }
      },
      {
        path: "/search",
        name: "search",
        component: () => import('@/views/search'),
        meta: { title: '搜索' }
      },
      {  
        path: "/msjx",
        name: "msjx",
        component: () => import('@/views/msjx'),
        meta: { title: '免申即享' }
      },
      {
        path: "/publish",
        name: "publish",
        redirect: '/publish/policylist',
        component: () => import('@/views/Publish/newIndex.vue'),
        meta: { title: '政策中心' },
        children: [
          { 
            path: '/publish/policylist',
            name: "policylist",
            component: () => import('@/views/Publish/PolicyList'),
            meta: { title: '政策中心' }
          },
          { 
            path: '/publish/policycontent',
            name: "policycontent",
            component: () => import('@/views/Publish/PolicyContent'),
            meta: { title: '政策内容' }
          }
        ]
      },
      {
        path: "/cashapply",
        name: "cashapply",
        redirect: '/cashapply/applylist',
        component: () => import('@/views/ApplyType'),
        meta: { title: '兑现申报' },
        children: [
          {
            path: "/cashapply/applylist",
            name: "applylist",
            component: () => import('@/views/ApplyType/ApplyList'),
            meta: { title: '兑现申报' }
          }, 
          {
            path: "/cashapply/policydetail",
            name: "policydetail",
            component: () => import('@/views/ApplyType/PolicyDetail'),
            meta: { title: '事项详情' }
          },
          {
            path: "/cashapply/user",
            name: "user",
            component: () => import('@/views/ApplyType/User'),
            meta: { title: '用户须知' }
          },
          {
            path: "/cashapply/apply",
            name: "apply",
            redirect: '/cashapply/apply/baseinfo',
            component: () => import('@/views/ApplyType/Apply'),
            // meta: { title: '政策申报' },
            children: [
              {
                path: '/cashapply/apply/baseinfo',
                name: 'baseinfo',
                component: () => import('@/views/ApplyType/Apply/baseInfo'),
                meta: { title: '基本信息' }
              },
              {
                path: '/cashapply/apply/bussinfo',
                name: 'bussinfo',
                component: () => import('@/views/ApplyType/Apply/bussInfo'),
                meta: { title: '业务信息' }
              },
              {
                path: '/cashapply/apply/phupload',
                name: 'phupload',
                component: () => import('@/views/ApplyType/Apply/phupload'),
                meta: { title: '材料上传' }
              },
              {
                path: '/cashapply/apply/xyinfo',
                name: 'xyinfo',
                component: () => import('@/views/ApplyType/Apply/xyinfo'),
                meta: { title: '协议信息' }
              },
              {
                path: '/cashapply/apply/xyupload',
                name: 'xyupload',
                component: () => import('@/views/ApplyType/Apply/xyupload'),
                meta: { title: '材料上传' }
              },
              {
                path: '/cashapply/apply/finish',
                name: 'finish',
                component: () => import('@/views/ApplyType/Apply/finish'),
                meta: { title: '办理完成' }
              }
            ]
          }
        ]
      },
      {
        path: "/personcenter",
        name: "personcenter",
        redirect: "/personcenter/wdbj",
        component: () => import('@/views/PersonCenter'),
        meta: { title: '用户中心', keepAlive: false },
        children: [
          // {
          //   path: '/personcenter/zcdx',
          //   name: 'Zcdx',
          //   component: () => import('@/views/PersonCenter/Zcdx'),
          //   meta: { title: '政策兑现', keepAlive: false }
          // },
          // {
          //   path: '/personcenter/msjxapply',
          //   name: 'Msjx',
          //   component: () => import('@/views/PersonCenter/Msjx'),
          //   meta: { title: '免审即享列表', keepAlive: false }
          // },
          {
            path: '/personcenter/wdbj',
            name: 'Wdbj',
            component: () => import('@/views/PersonCenter/Wdbj'),
            meta: { title: '我的办件', keepAlive: false }
          },
          {
            path: '/personcenter/zl',
            name: 'Zl',
            component: () => import('@/views/PersonCenter/Zl'),
            meta: { title: '我的资料', keepAlive: false }
          },
          { 
            path: '/personcenter/sc',
            name: 'Sc',
            component: () => import('@/views/PersonCenter/Sc'),
            meta: { title: '我的收藏', keepAlive: false }
          },
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === 'staging' ? '/ceshi/' : '/',
  routes,
  scrollBehavior: () => ({ y: 0 }),
});

let currentTime = null;
let startTime = Date.now();
router.beforeEach((to, form, next) => {

  // if (to) {
  //   currentTime = Date.now();
  //   const sed = parseInt((currentTime - startTime) / 1000);
  //   store.dispatch('dealLogger', {
  //     type: '页面切换',
  //     prePage: form.meta.title,
  //     curPage: to.meta.title,
  //     timeStay: `停留了${sed}`
  //   })

  //   startTime = Date.now()
  // }
 
  if (to.query.token) {
    setToken(to.query.token);
    store.commit('SetToken', to.query.token);
    store.dispatch('LOGIN').then(() => {
      store.commit('SetName', store.state.user.userInfo.companyName);
      next()
    }) 
  }
 
  const hasToken = getApplyToken();
  if (hasToken) {
    if (to.fullPath.indexOf('personcenter') > 0) {
      store.commit('SetPersonCenter', true);
    } else {
      store.commit('SetPersonCenter', false);
    }
    next()
  }
  next()
})

export default router;
